<!--TeacherHome:教师平台首页 2021/03/17 09:41:55 YuAng-->

<template>
  <ts-page-layout class="its-teacher-home" center>
    <div class="its-home-left">
      <!-- 快捷入口  -->
      <te-quick :link="link" :has-download.sync="hasDownload"></te-quick>
      <!-- 待办任务 -->
      <te-task :link="link" :style="taskStyle"></te-task>
    </div>
    <div ref="homeRight" class="its-home-right">
      <!-- 轮播图 -->
      <te-banner :has-banner.sync="hasBanner"></te-banner>
      <div class="its-right-activity" :style="rightStyle">
        <p class="its-home-tab">
          <span @click="activeName = 'teacher'" data-io-click="tracker" :class="{active: activeName === 'teacher'}">教师动态</span>
          <span @click="activeName = 'student'" data-io-click="tracker" :class="{active: activeName === 'student'}">学生动态</span>
          <span class="line" :style="{left: activeName === 'teacher' ? '94px' : '188px'}"></span>
        </p>
        <keep-alive>
          <component :is="'te-activity-' + activeName" :link=link style="height: calc(100% - 58px);overflow: auto;"></component>
        </keep-alive>
      </div>
    </div>
    <download-qr-code></download-qr-code>
  </ts-page-layout>
</template>
<script>
import DownloadQrCode from './components/DownloadQrCode.vue'
import TeActivityTeacher from './components/TeActivityTeacher.vue'
import TeActivityStudent from './components/TeActivityStudent.vue'
import TeBanner from './components/TeBanner.vue'
import TeQuick from './components/TeQuick.vue'
import TeRank from './components/TeRank.vue'
import TeTask from './components/TeTask.vue'
export default {
  components: { TeBanner, TeTask, TeQuick, TeRank, TeActivityTeacher, DownloadQrCode, TeActivityStudent },
  name: 'TeacherHome',
  data() {
    return {
      hasDownload: false,
      hasBanner: false,
      link: {
        'synchronous': '/training/#/resource/synchronous?from=teacher_home',
        'phase': '/training/#/resource/phase?from=teacher_home',
        'answersheet': '/training/#/create?type=answer-sheet&from=teacher_home'
      },
      activeName: 'teacher'
    }
  },
  computed: {
    taskStyle: function () {
      let height = 210
      if (this.hasDownload) {
        height = 303
      }
      return { height: 'calc(100% - ' + height + 'px)' }
    },
    rightStyle: function () {
      let height = 0
      if (this.hasBanner) {
        height = 140
      }
      return { height: 'calc(100% - ' + height + 'px)' }
    }
  },
  created() {
    this.$root.activeNavigation()
    this.setLinks()
  },
  methods: {
    setLinks: function () {
      let navs = sessionStorage.getItem('iclass-nav1')
      if (navs) {
        navs = JSON.parse(navs).find(item => item.name === 'jx').children
      }
      if (navs) {
        for (let index = 0; index < navs.length; index++) {
          const nav = navs[index];
          this.link[nav.name] = nav.url
        }
      }
    }
  }
}
</script>

<style scoped>
.its-teacher-home {
  width: 100%;
  padding-top: 20px;
  height: calc(100vh - 148px);
}

.its-teacher-home::after {
  clear: both;
  content: "";
  display: block;
}

.its-home-left {
  width: calc(100% - 400px);
  height: 100%;
  float: left;
}

.its-home-right {
  width: 380px;
  height: 100%;
  float: right;
}

.its-home-right >>> .its-part-title {
  width: calc(100% - 40px);
  line-height: 16px;
  height: 16px;
  font-size: 16px;
  font-weight: 500;
  border-left: 4px solid #0580ff;
  padding-left: 6px;
  margin: 20px 20px 14px 20px;
}

.its-home-right >>> .nodata-tips {
  zoom: 0.8;
  -ms-zoom: 0.8;
  margin-left: 10%;
}

.its-teacher-home >>> .its-icon-question-circle {
  color: #999999;
  margin-left: 4px;
}

.its-home-right >>> .its-part-title a {
  font-size: 13px;
  color: #0580ff;
  float: right;
}

.its-home-right >>> .its-part-title .empty {
  color: #aaaaaa;
  font-size: 12px;
  vertical-align: top;
}

.its-right-activity {
  background: #ffffff;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.03);
  border-radius: 4px;
}

.its-home-tab {
  padding: 20px 0 8px 0;
  margin: 0 16px;
  font-size: 16px;
  color: #262626;
  position: relative;
  font-weight: bold;
  text-align: center;
  border-bottom: 1px solid #e5e5e5;
}

.its-home-tab span {
  margin: 0 20px 0 10px;
  display: inline-block;
  cursor: pointer;
}

.its-home-tab span.active {
  color: #0580ff;
}

.its-home-tab .line {
  position: absolute;
  width: 38px;
  height: 2px;
  background: #0580ff;
  border-radius: 1px;
  bottom: 0px;
  left: 0;
}
</style>